import React from 'react'
import List from '@mui/material/List'
import ListItemIcon from '@mui/material/ListItemIcon'
import ListItemText from '@mui/material/ListItemText'
import Divider from '@mui/material/Divider'
import Collapse from '@mui/material/Collapse'

import IconExpandLess from '@mui/icons-material/ExpandLess'
import IconExpandMore from '@mui/icons-material/ExpandMore'

import AppMenuItemComponent from './AppMenuItemComponent'
import { ClickActionEvent } from '../../util/analytics'


const AppMenuItem  = props => {
  const {
    name,
    id,
    route,
    Icon,
    items = [],
    menuSelected,
    setMenu,
    toggleDrawer,
    closeExpandableMenus,
    closeMenusVersion,
    isChild = false,
    onSectionSelect,
  } = props
  const isExpandable = items && items.length > 0
  const [open, setOpen] = React.useState(false)

  React.useEffect(() => {
    if (isExpandable && items.some((item) => item.id === menuSelected)) {
      setOpen(true)
    }
  }, [isExpandable, items, menuSelected])

  React.useEffect(() => {
    if (isExpandable && closeMenusVersion > 0) {
      setOpen(false)
    }
  }, [closeMenusVersion, isExpandable])

  const menuClickedEvent = (menuName) => {
    ClickActionEvent("Menu " +menuName, "homepage mobile", "app menu clicked")
  }

  function handleClick() {
    setMenu(id)
    if (isExpandable) {
      setOpen((currentOpen) => !currentOpen)
    } else if (!isChild) {
      closeExpandableMenus()
    }
    menuClickedEvent(id)
  }

  const menuItemSx = {
    '&:hover': { backgroundColor: '#D2ECE7' },
  }

  const menuItemIconSx = { color: '#061B3A' }
  const selectedMenuItemSx = menuSelected === id ? {
    backgroundColor: '#0F766E',
    color: '#FFFFFF',
    '& .MuiListItemIcon-root': { color: '#FFFFFF' },
    '& .MuiListItemText-primary': { color: '#FFFFFF', fontWeight: 700 },
    '&:hover': { backgroundColor: '#115E59' },
  } : {}

  const MenuItemRoot = (
    // If the item is expandable, don't pass `link` (parent toggles only).
    // Also, if a `route` is provided, don't pass `link` — route-based
    // navigation should take precedence over section scrolling.
  <AppMenuItemComponent sx={{ ...menuItemSx, ...selectedMenuItemSx }} link={isExpandable ? null : (route ? null : id)} route={route} toggleDrawer={toggleDrawer} onSectionSelect={onSectionSelect} onClick={handleClick}>
      {/* Display an icon if any */}
      {id === 'home' ? (
        <ListItemIcon
          sx={{ ...menuItemIconSx, minWidth: 56 }}
        >
          <img
            src="/javedinfinte-logo-128.png"
            alt="javedinfinite"
            style={{ width: 30, height: 32, objectFit: 'contain' }}
          />
        </ListItemIcon>
      ) : !!Icon && (
        <ListItemIcon sx={menuItemIconSx}>
          <Icon />
        </ListItemIcon>
      )}
      <ListItemText primary={name} inset={!Icon} />
      {/* Display the expand menu if the item has children */}
      {isExpandable && !open && <IconExpandMore />}
      {isExpandable && open && <IconExpandLess />}
    </AppMenuItemComponent>
  )

  const MenuItemChildren = isExpandable ? (
    <Collapse in={open} timeout="auto" unmountOnExit>
      <Divider />
      <List component="div" disablePadding>
        {items.map((item, index) => (
          <AppMenuItem
            setMenu={setMenu}
            closeExpandableMenus={closeExpandableMenus}
            {...item}
            menuSelected={menuSelected}
            closeMenusVersion={closeMenusVersion}
            isChild
            toggleDrawer={toggleDrawer}
            onSectionSelect={onSectionSelect}
            key={index}
          />
        ))}
      </List>
    </Collapse>
  ) : null

  return (
    <>
      {MenuItemRoot}
      {MenuItemChildren}
    </>
  )
}

export default AppMenuItem
